import useSWR, { BareFetcher, useSWRConfig } from 'swr';
import { dictionaryService } from '@/services/api';
import { config } from '@/config';
import { AwaitedReturnType, FetchErrorsType } from '@/types';

const API_URL = config.api.url.dictionary;

export const useStatesQuery = (countryCode?: string) => {
    const { data } = useSWR(
        countryCode ? [`${API_URL}/states`, countryCode] : null,
        ([, countryCode]) => dictionaryService.getStates(countryCode),
    );
    return data;
};

export const useZipLocationsQuery = (
    countryCode: string | undefined,
    zip: string | undefined,
    shouldFetch = true,
) => {
    const { mutate } = useSWRConfig();
    const key = [`${API_URL}/zip-location`, countryCode, zip];
    const fetcher: BareFetcher<AwaitedReturnType<typeof dictionaryService.getZipLocations>> = ([
        ,
        countryCode,
        zip,
    ]: [_: string, countryCode: string, zip: string]) =>
        dictionaryService.getZipLocations(countryCode, zip);

    const { data, error, isLoading } = useSWR<
        AwaitedReturnType<typeof dictionaryService.getZipLocations>,
        FetchErrorsType
    >(countryCode && zip && shouldFetch ? key : null, fetcher);

    return { data, error, mutate: () => mutate(key), isLoading };
};
